<template>
  <el-dialog
    title="汇款底单详细信息"
    :visible.sync="dialogVisible"
    width="700px"
    @close="handleClose"
  >
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇款编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.telegraphicTransferNo }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇入公司：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.importCompany }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                币种：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.currencyName }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                代理名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.orderUnit || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇款日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.remittanceTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇款金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.remittanceAmount }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇入行：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.importBank }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇入账户：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.importAccount }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                实际付款人：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.drawee }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                付款用途：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.strRemittanceScenario }}
              </div>
            </div>
          </div>

          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收款单号：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.telegraphicTransferNum }}
              </div>
            </div>
          </div>

          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                实际到款金额：
              </div>
              <div class="rj-baseinfo__item">
                <span v-if="info.telegraphicTransferNum === ''">-</span>
                <span v-else>
                  {{ info.actualRemittanceAmount }}
                </span>
              </div>
            </div>
          </div>

          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否委托付款：
              </div>
              <div class="rj-baseinfo__item">
                <span v-if="info.entrustedFlg === 1">是</span>
                <span v-if="info.entrustedFlg === 0">否</span>
              </div>
            </div>
          </div>

          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                可用余额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.availableAmount }}
              </div>
            </div>
          </div>

          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                手续费：
              </div>
              <div class="rj-baseinfo__item">
                <span v-if="info.telegraphicTransferNum === ''">-</span>
                <span v-else-if="(info.remittanceAmount - info.actualRemittanceAmount).toFixed(2) <= 50">{{ (info.remittanceAmount - info.actualRemittanceAmount).toFixed(2) }}</span>
                <span v-else-if="(info.remittanceAmount - info.actualRemittanceAmount).toFixed(2) > 50" style="color: red;">{{ (info.remittanceAmount - info.actualRemittanceAmount).toFixed(2) }}</span>
              </div>
            </div>
          </div>

          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否跨币种：
              </div>
              <div class="rj-baseinfo__item">
                <span v-if="info.crossCurrencyFlag === 1">是</span>
                <span v-if="info.crossCurrencyFlag === 0">否</span>
              </div>
            </div>
          </div>

          <template v-if="info.crossCurrencyFlag === 1">
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇率日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.exchangeRateDate }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇率取值规则：
                </div>
                <div class="rj-baseinfo__item">
                  <span v-if="info.exchangeRateRule === 'sameDayMiddleRate'">客户付款当日汇率中间价</span>
                  <span v-if="info.exchangeRateRule === 'poAgreedRate'">PO 约定汇率</span>
                  <span v-if="info.exchangeRateRule === 'otherAgreedRate'">其他约定汇率</span>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  目标币种：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.targetCurrencyName }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  本次应收金额：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.currentReceivableAmount }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇率值：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.exchangeRate }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  关联虚拟来款单：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.virtualTelegraphicTransferNo }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  转换金额：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.convertedAmount }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  虚拟来款单备注：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.erpVirtualReceiptRemark }}
                </div>
              </div>
            </div>
          </template>

          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                关联合同：
              </div>
            </div>
          </div>

          <div class="view-recording__full-width">
            <el-table :data="info.telegraphicContractRelationList" border style="width: 100%">
              <el-table-column prop="cotractNum" label="合同编号" align="left" fixed="left" />
              <el-table-column prop="splitAmount" label="拆分金额 *" align="right" header-align="left" />
              <el-table-column prop="remittanceType" label="付款类型 *" align="left">
                <template v-slot="{ row }">
                  <span v-if="row.remittanceType === 0">现销付款/赊销预付款</span>
                  <span v-if="row.remittanceType === 1">赊销回款</span>
                </template>
              </el-table-column>
              <el-table-column prop="ledgerNumber" label="台账 *" align="left" />
            </el-table>
          </div>

          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                备注：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.remark }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>附件</div>
    <el-table :data="fileList" border style="width: 100%">
      <el-table-column prop="fileName" label="文件名称" align="left" fixed="left" />
      <el-table-column prop="createBy" label="上传人" align="left" />
      <el-table-column prop="createTime" label="上传时间" align="left" />
      <el-table-column label="操作" align="left" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="downloadAttachment(row)">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <br>
    <div>电汇所指订单表</div>
    <br>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
      <el-table-column prop="contractNum" label="锐捷电子商务合同编号" align="left" />
      <el-table-column prop="orderNo" label="分配订单号" align="left" />
      <el-table-column prop="actualSettlementAmount" label="订单总金额" align="right" header-align="left" />
      <el-table-column prop="assignedAmount" label="本次分配金额" align="right" header-align="left" />
      <el-table-column prop="assignedDate" label="分配日期" align="left" />
    </el-table>

    <div v-if="tableData.length">
      金额小计：{{ info.amountSubtotal }}
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ViewRecording',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => ({})
    },
    fileList: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible;
      },
      set (value) {
        this.$emit('update:visible', value);
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('close');
    },
    downloadAttachment (row) {
      if (row && row.fileUrl) {
        window.location.href = row.fileUrl;
      }
      // 后期可能需要补充下载逻辑，与查看水单下载逻辑保持一致
      // this.$emit('downLoadFile', row);
    }
  }
};
</script>

<style scoped>
.view-recording__full-width {
  width: 100%;
}
</style>
